module.exports = __webpack_public_path__ + "img/Grupo 73.7cb0f139.png";